import React from "react";
import "./ClientInfo.css";
import CustomDropdown from "../../../../../Components/CustomDropdown/CustomDropdown";
import CustomTimeSelector from "../../../../Components/CustomTimeSelector/CustomTimeSelector";
import CustomTable from "../../../../Components/CustomTable/CustomTable";
const ClientInfo = () => {
  const columns = [
    { key: "serial_no", title: "Sl. No" },
    { key: "file_name", title: "File Name" },
    { key: "file_type", title: "File Type" },
    { key: "download", title: "Download" },
    { key: "updated_date", title: "Updated Date" },
  ];
  return (
    <div className="cltdetails__clientinfo_page">
      <div className="cltdetails__clientinfo_contentwrap">
        <div className="cltdetails__clientinfo_contentbox">
          <div className="cltdetails__clientinfo_cboxheader">Clients Info</div>
          <div className="cltdetails__clientinfo_cboxbody">
            <div className="cltdetails__clientinfo_cboxrow">
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    File No.{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__clientinfo_cboxfield"
                      placeholder="Undefined"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol"></div>
              <div className="cltdetails__clientinfo_cboxcol"></div>
            </div>
            <div className="cltdetails__clientinfo_cboxrow">
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Name{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__clientinfo_cboxfield"
                      placeholder="Name"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Email{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="email"
                      className="cltdetails__clientinfo_cboxfield"
                      placeholder="Email"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Phone Number{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__clientinfo_cboxfield"
                      placeholder="Enter Number"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__clientinfo_cboxrow">
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Alt Phone{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__clientinfo_cboxfield"
                      placeholder="Enter Number"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Mailing State{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__clientinfo_cboxfield"
                      placeholder="Enter State"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Mailing Zip{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__clientinfo_cboxfield"
                      placeholder="Enter Zip"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__clientinfo_cboxrow">
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    India#{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__clientinfo_cboxfield"
                      placeholder="Enter your Number"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    FBAR Paid{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__clientinfo_cboxfield"
                      placeholder="Enter Amount"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Old Comment{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__clientinfo_cboxfield"
                      placeholder="Hello"
                    />
                    <button className="cltdetails__clientinfo_cboxfieldbtn">
                      View
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__clientinfo_cboxrow">
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Status{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <CustomDropdown
                      customStyles={{
                        height: 56,
                        borderColor: "lightgrey",
                        marginTop: 0,
                      }}
                      options={["opt1"]}
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Sub Status{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <CustomDropdown
                      options={["opt1"]}
                      customStyles={{
                        height: 56,
                        borderColor: "lightgrey",
                        marginTop: 0,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Staff{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__clientinfo_cboxfield"
                      value="Chandu@serenetax.com"
                    />
                    <button className="cltdetails__clientinfo_cboxfieldbtn">
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__clientinfo_cboxrow">
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Comment{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <textarea
                      type="text"
                      className="cltdetails__clientinfo_cboxtextarea"
                      placeholder="Type your comment"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol"></div>
              <div className="cltdetails__clientinfo_cboxcol"></div>
            </div>
          </div>
        </div>
        <div className="cltdetails__clientinfo_contentbox">
          <div
            className="cltdetails__clientinfo_cboxheader"
            style={{ opacity: "0.65" }}
          >
            Time Setting
          </div>
          <div className="cltdetails__clientinfo_cboxbody">
            <div className="cltdetails__clientinfo_cboxrow">
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Timezone
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <CustomDropdown
                      options={["Central Standard Time(CST) "]}
                      customStyles={{
                        height: 56,
                        borderColor: "lightgrey",
                        marginTop: 0,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    US Time
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <CustomTimeSelector />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  {" "}
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Indian Time
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <CustomTimeSelector />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__clientinfo_cboxrow">
              <div className="cltdetails__clientinfo_cboxcol">
                <div className="cltdetails__clientinfo_cboxfieldbox">
                  <label className="cltdetails__clientinfo_cboxfieldlbl">
                    Date{" "}
                  </label>
                  <div className="cltdetails__clientinfo_cboxfieldwrap">
                    <input
                      type="date"
                      className="cltdetails__clientinfo_cboxfield"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__clientinfo_cboxcol"></div>
              <div className="cltdetails__clientinfo_cboxcol"></div>
            </div>
          </div>
        </div>
        <CustomTable
          columns={columns}
          headerStyle={{
            minHeight: "70px",
            backgroundColor: "rgba(4, 153, 151, 1)",
          }}
        />
      </div>
      <div className="cltdetails__clientinfo_contentwrap">
        <div className="cltdetails__clientinfo_bottombtns">
          <button className="cltdetails__clientinfo_bbtnfilled">Submit</button>
          <button className="cltdetails__clientinfo_bbtnoutlined">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientInfo;
